import {
  ContractCreate,
  ContractEdit,
  ContractShow
} from 'pages/certificates_management/contracts';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'contracts',
  label: 'Contratos',
  create: ContractCreate,
  edit: ContractEdit,
  show: ContractShow,
  actions: ['show', 'create', 'edit'],
  parentName: 'certificate_management/companies/:companyId'
};

export default generateResources(resource);
